import {
  DropdownAnchor,
  DropdownMenuOptionPropsType,
  DropdownMenuOptionType,
  IconLogOut,
  RefPosition,
  useDropdown,
} from '@bimone/bimtrackreactcomponents';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useErrorHandler } from 'react-error-boundary';
import { User } from '@bimone/bimtrack-core';
import { useSession } from '../../../modules/session';

export interface NavBarDropDownMenuResult {
  states: {
    user?: User;
    options: DropdownMenuOptionPropsType[];
    triggerButtonRef?: RefObject<HTMLDivElement>;
    dropdownMenuContainerRef?: RefObject<HTMLDivElement>;
    open: boolean;
    position: RefPosition;
  };
  actions: {
    closeDropdown: () => void;
    openDropdown: () => void;
  };
}

export function useNavBarDropDownMenu(): NavBarDropDownMenuResult {
  const { signoutRedirect } = useAuth();
  const setError = useErrorHandler();
  const { t } = useTranslation('navBar');
  const session = useSession();

  const handleOnClickLogout = async (): Promise<void> => {
    try {
      await signoutRedirect();
    } catch (error) {
      setError(error);
    }
  };

  const options: DropdownMenuOptionPropsType[] = [
    {
      id: 'logout',
      optionType: DropdownMenuOptionType.BUTTON,
      icon: <IconLogOut key={'icon-logout'} />,
      content: t('logout'),
      onClick: handleOnClickLogout,
    },
  ];

  const {
    triggerButtonRef,
    dropdownMenuContainerRef,
    open,
    position,
    actions: { openDropdownAtPosition, closeDropdown },
  } = useDropdown<HTMLDivElement>(DropdownAnchor.BOTTOM_RIGHT);

  const openDropdown = (): void =>
    openDropdownAtPosition(
      ({ left, top, height }): RefPosition => ({
        left,
        top: top + height,
        height: 0,
        right: 0,
      })
    );

  return {
    states: {
      user: session.user,
      options,
      triggerButtonRef,
      dropdownMenuContainerRef,
      open,
      position,
    },
    actions: {
      openDropdown,
      closeDropdown,
    },
  };
}
